


































































































import { Component, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { changeTextColor } from "@/utils/color";
import BusinessTagCreate from "./BusinessTagCreate.vue";

@Component({
  components: {
    BusinessTagCreate
  },
  computed: {
    ...mapState({
      loading: "loading"
    }),
    ...mapState("Auth", {
      business: "activeBusiness"
    }),
    ...mapState("BusinessTag", {
      list: "list"
    })
  },
  methods: {
    changeTextColor
  }
})
export default class BusinessTags extends Vue {
  list!: Model[];
  business!: Model;
  loading!: boolean;

  showEdit = false;
  tmpTag: Model | null = null;

  created() {
    if (!this.list.length) {
      this.$store.dispatch("BusinessTag/fetchList", {
        params: {
          business_oid: this.business.object_id
        }
      });
    }
  }

  toggleEdit(tag = null) {
    this.showEdit = !this.showEdit;
    this.tmpTag = tag ? Object.assign({}, tag) : tag;
  }

  async updateTag() {
    if (!this.tmpTag) {
      return;
    }
    await this.$store.dispatch("BusinessTag/update", {
      object_id: this.tmpTag.object_id,
      data: {
        ...this.tmpTag,
        business_oid: this.business.object_id
      }
    });
    this.showEdit = false;
  }

  deleteTag(tag) {
    this.$store.dispatch("BusinessTag/delete", {
      object_id: tag.object_id,
      data: {
        business_oid: this.business.object_id
      }
    });
  }
}
